import { useParams } from 'react-router-dom';
import { query } from '../../../util/api/query';
import type { VatRateDto } from '../types/VatRateDto';

export function useVatRate(vatRateId?: string): number | undefined {
	const { organisation } = useParams();

	const vatRatesQuery = query<VatRateDto[]>(`${organisation}/vat-rates/all`);

	if (!vatRateId) {
		return undefined;
	}

	return vatRatesQuery.data?.value.find((v) => v.id === vatRateId)?.rate;
}
